import * as React from 'react';
import { TextField, DialogFooter, Button, ButtonType } from 'office-ui-fabric-react';

interface IProps {
	journeyTitle: string;
	titleChange: (val: string) => void;
	saveJourneyAs: () => void;
	closeDialog: () => void;
	isSaving: boolean;
}

export class SaveAsContent extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);
    }

	public render() {

		return (
			<div>
				<TextField label={ 'New Journey Title' } disabled={this.props.isSaving} value={ this.props.journeyTitle } onChanged={ (val) => this.props.titleChange(val) } />
				<DialogFooter>
                    <Button buttonType={ ButtonType.normal } disabled={this.props.isSaving} onClick={ () => this.props.closeDialog() }>Cancel</Button>
					<Button buttonType={ ButtonType.primary } onClick={ () => this.props.saveJourneyAs() } disabled={ this.props.isSaving || this.props.journeyTitle.length === 0 } >Save</Button>
                </DialogFooter>
			</div>
		);

	}
}


// WEBPACK FOOTER //
// ./source/ts/components/tools/save-as.tsx